// src/components/DashboardContainer.js
import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import DashboardHeader from './DashboardHeader';
import TrialBanner from './TrialBanner';
import AppDrawer from '../AppDrawer'; // Import the new AppDrawer

const DashboardContainer = ({ userName, userRole, notifications, onLogout, children, avatarUrl }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // State for mobile drawer and collapsed state
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [drawerCollapsed, setDrawerCollapsed] = useState(true);
  
  // Calculate drawer width
  const drawerWidth = !isMobile && drawerCollapsed ? 65 : 260;
  
  // Toggle drawer function to pass to header and drawer
  const toggleDrawer = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      {/* App Drawer */}
      <AppDrawer 
        userName={userName}
        userRole={userRole}
        notifications={notifications}
        onLogout={onLogout}
        open={mobileDrawerOpen}
        onClose={() => setMobileDrawerOpen(false)}
        isMobile={isMobile}
        collapsed={!isMobile && drawerCollapsed}
        onCollapsedChange={setDrawerCollapsed}
        avatarUrl={avatarUrl}
      />
      
      {/* Main content area */}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        {/* Keep your existing header */}
        <DashboardHeader 
          userName={userName} 
          userRole={userRole} 
          notifications={notifications} 
          onLogout={onLogout}
          onMenuClick={toggleDrawer} // Add this prop to handle menu button click
          isMobile={isMobile}
          avatarUrl={avatarUrl}
        />
        
        {/* Keep your trial banner */}
        <TrialBanner />
        
        {/* Content area */}
        <Box sx={{ flexGrow: 1, p: 3, overflow: 'auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardContainer;